<template>
  <div>
    <vue-headful title="Archief" />
    <Header page_title="Archief" />
    <div >
      <div class="px-4 mx-2">
        <div class="container-fluid px-0 pb-1 mb-2">
          <p class="mb-3">
            <strong v-if="results.meta.total == 1">{{ results.meta.total }} afgeronde opdracht</strong>
            <strong v-else>{{ results.meta.total }} afgeronde opdrachten</strong>
          </p>
          <job-filter @filter-change="filterChanged" :showAll="false" :subbranch="true" />
          <div class="mb-5" v-if="results ? results.data && results.data.length > 0 : false">
            <JobCard
              v-for="job in results.data"
              :key="job.id"
              :job="job"
              :job_ids="history_ids"
              :closed="true"
              :arrow="true"
            />
            <Pagination :results="results" :api="api" @page-change="pageChanged" />
          </div>
          <Empty v-else text="Hier vind je de opdrachten die je hebt afgerond." />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import JobCard from "@/components/JobCard.vue";
import JobFilter from "@/components/JobFilter.vue";

export default {
  data: function() {
    return {
      api: "jobs/accepted",
      results: null,
      history_ids: null,
      filterValues: {
        showAll: false,
        maxShown: 20,
        subbranch: ''
      },
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.results = await this.getListwithPages("jobs/accepted");
      if (this.results.data.length > 1) {
        this.history_ids = this.results.data.map(({ job_id }) => job_id);
      }
      this.$store.state.loading = false;
    },
    async pageChanged(data) {
      this.results = await this.getListwithPages(data);
    },
    async filterChanged(data) {
      this.filterValues = data;
      this.$store.state.loading = true;

      if(this.filterValues.subbranch === '1')
        this.api = 'jobs/accepted?subbranch=1';
      else if(this.filterValues.subbranch === '2')
        this.api = 'jobs/accepted?subbranch=2';
      else
        this.api = 'jobs/accepted';

      this.results = await this.getListwithPages(this.api);
      this.$store.state.loading = false;
    }
  },
  components: {
    JobFilter,
    JobCard
  }
};
</script>

<style scoped></style>
